/**
 * @generated SignedSource<<6e875555cd5fa9a62d65b090844f7794>>
 * @relayHash 5f6759d36b9b413ed3059f223a693a26
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b0cee6e99f9e6f64c51de37fc7d9130eed7a71d3657944c1caa130bf15dff09a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type filteredCardsQuery$variables = {
  boardId: string;
  customFilterIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  filterJql?: string | null | undefined;
  issueIds: ReadonlyArray<string | null | undefined>;
};
export type filteredCardsQuery$data = {
  readonly boardScope: {
    readonly filteredCardIds: ReadonlyArray<string | null | undefined> | null | undefined;
  } | null | undefined;
};
export type filteredCardsQuery = {
  response: filteredCardsQuery$data;
  variables: filteredCardsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customFilterIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterJql"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueIds"
},
v4 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v5 = {
  "args": [
    {
      "kind": "Variable",
      "name": "customFilterIds",
      "variableName": "customFilterIds"
    },
    {
      "kind": "Variable",
      "name": "filterJql",
      "variableName": "filterJql"
    },
    {
      "kind": "Variable",
      "name": "issueIds",
      "variableName": "issueIds"
    }
  ],
  "kind": "ScalarField",
  "name": "filteredCardIds"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "filteredCardsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "filteredCardsQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b0cee6e99f9e6f64c51de37fc7d9130eed7a71d3657944c1caa130bf15dff09a",
    "metadata": {},
    "name": "filteredCardsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a67046d1d497413b9042dcb471052fd9";

export default node;
